<template>
  <div>
    <NotificationContainer />
    <router-view></router-view>
  </div>
</template>
<script>
import NotificationContainer from "./Notification/NotificationContainer.vue";
export default {
  components: { NotificationContainer },
  name: "App",
};
</script>
